const megaMenu = document.querySelector('.main-navigation .mega-menu')
if ( megaMenu ) {
  // position megaMenu top to be below header
  const megaMenuGrid = megaMenu.querySelector('.sub-menu')

  megaMenu.addEventListener('mouseenter', e => {
    const targetRect = megaMenu.getBoundingClientRect();
    const top = targetRect.top + targetRect.height;
    megaMenuGrid.style.top = top + 'px'
  })

}
